import { UPDATE_CART_ITEMS,UPDATE_LIST_ITEMS} from "/src/constants";

let cloneObject = function (obj) {
    return JSON.parse(JSON.stringify(obj))
};

let newState = { cartItems : {}  , listItems : {} };

export default function CartReducer(state,action)
{
    switch (action.type){

        case UPDATE_CART_ITEMS:

            newState = cloneObject(state);
            if (action.data !== null) {
                newState = Object.assign({}, newState, {
                    ...action.data,
                    cartItems: action.data,
                });
            }

            return  newState ;


        case UPDATE_LIST_ITEMS:

            newState = cloneObject(state);
            if (action.data !== null) {
                newState = Object.assign({}, newState, {
                    ...action.data,
                    listItems: action.data,
                });
            }

            return  newState ;

            default:
            return state || newState;
    }

}

